<template>
    <div class="bg-gray-100 py-8 mb-4 px-[10%]" id="assortiment">
      <!-- Titel -->
      <div class="text-center mb-12">
        <h2 class="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">Ons Assortiment</h2>
        <p class="text-lg text-gray-600">
          Ontdek ons uitgebreide aanbod van verse en heerlijke producten.
        </p>
      </div>
  
      <!-- Grid met kaarten -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        <div
          v-for="item in assortiment"
          :key="item.title"
          class="relative rounded-xl shadow-lg overflow-hidden bg-cover bg-center group hover:scale-105 transition transform h-auto p-4"
          :style="{ backgroundImage: `url(${item.image})` }"
          @click="toggleCard(item.title)"
        >
          <!-- Overlay -->
          <div
            class="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition"
            :class="{ 'bg-black/70': selectedCard === item.title }"
          ></div>
  
          <!-- Kaartinhoud -->
          <div class="relative z-10 flex flex-col h-full">
            <h3 class="text-xl font-bold text-white mb-2">{{ item.title }}</h3>
            <span class="text-gray-300 text-sm">{{ item.description }}</span>
  
            <!-- Productenlijst -->
            <div
              v-if="selectedCard === item.title"
              :class="item.products.length === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'"
              class="mt-4 grid gap-2"
            >
              <div
                v-for="product in item.products"
                :key="product"
                class="bg-gray-200 text-gray-700 rounded p-2 text-center text-sm"
              >
                {{ product }}
              </div>
            </div>
  
            <!-- Sluitknop verplaatst naar de rechterbovenhoek -->
            <div
              v-if="selectedCard === item.title"
              class="absolute top-0 right-0 cursor-pointer text-white bg-red-500 hover:bg-red-600 rounded-full w-8 h-8 flex items-center justify-center shadow-md transition"
              @click.stop="toggleCard(item.title)"
            >
              <i class="fas fa-times"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "AssortimentTotaal",
    data() {
      return {
        selectedCard: null,
        assortiment: [
          {
            title: "Verse Vis",
            description: "Dagelijks vers gevangen vis.",
            image: "/fresh.jpg",
            products: ["Kabeljauw", "Dorade", "Zeebaars", "Poon", "Griet", "Tarbot", "Schar", "Schol", "Slibtong", "Pieterman", "Forel", "Bot", "Zalmforel", "Zeeduivel", "Tonijn","Zalm", "Ansjovis", "Heilbot", "Heek", "Koolvis", "Rode Mul", "Rogvleugel", "Roodbaars", "Sardine", "Snoekbaars", "Skrei", "Schelvis", "Zeewolf", "Zonnevis", "Zwaardvis", "Calamaris", "Octopus"],
          },
          {
            title: "Gebakken Vis",
            description: "Heerlijke gebakken lekkernijen.",
            image: "fried.jpg",
            products: ["Kibbeling", "Lekkerbekje", "Torpedogarnalen", "Mosselen", "Garnalenkroket", "Fish & Chips", "Garnalennuggets", "Visfriet", "Calamaris", "Gamba's"],
          },
          {
            title: "Gerookte Vis",
            description: "Traditioneel gerookte smaken.",
            image: "smoked.jpg",
            products: ["Zalm", "Zalmsnippers", "Makreel", "Zalmmoot", "Paling", "Bokking", "Forel"],
          },
          {
            title: "Schaal- & Schelpdieren",
            description: "Direct van de zee naar uw bord.",
            image: "shell.jpg",
            products: ["Rivierkreeftvlees", "Fruit de mer", "Hollandse garnalen", "Mosselen", "Coquille", "Kokkels", "Kreeft", "Noorse garnalen", "Scampi", "Oesters"],
          },
          {
            title: "Verse Broodjes",
            description: "Perfect belegd en vers gebakken.",
            image: "sandwich.jpg",
            products: ["Broodje gerookte zalm", "Broodje paling", "Broodje haring", "Broodje krabsalade", "Broodje garnalensalade", "Broodje warme kibbeling"],
          },
          {
            title: "Complete Maaltijden",
            description: "Gemakkelijk en heerlijk.",
            image: "dish.jpeg",
            products: ["Verse maaltijden worden voor u bereid, vraag ons gerust naar de mogelijkheden!"],
          },
          {
            title: "Soepen",
            description: "Rijk gevuld",
            image: "soup.jpg",
            products: ["Onze heerlijke huisgemaakte soepen kunt u bij ons vinden in makkelijke emmertjes van 500ml"],
          },
        ],
      };
    },
    methods: {
      toggleCard(title) {
        this.selectedCard = this.selectedCard === title ? null : title;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Responsieve fixes */
  @media (max-width: 640px) {
    .grid-cols-3 {
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }
  }
  </style>
  